import { render, staticRenderFns } from "./Interactions.vue?vue&type=template&id=b872e5fc&scoped=true&"
import script from "./Interactions.vue?vue&type=script&lang=js&"
export * from "./Interactions.vue?vue&type=script&lang=js&"
import style0 from "./Interactions.vue?vue&type=style&index=0&id=b872e5fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b872e5fc",
  null
  
)

export default component.exports